var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.isLoading,
          expression: "isLoading",
        },
      ],
      staticClass: "memberInfo",
    },
    [
      _vm.currentUser
        ? [
            _c(
              "div",
              { staticClass: "bottons" },
              [
                _vm.currentUser.role !== "owner"
                  ? [
                      _c("el-button", {
                        attrs: { icon: "el-icon-edit", size: "mini" },
                        on: {
                          click: function ($event) {
                            _vm.isShowingManagerEditDialog = true
                          },
                        },
                      }),
                      _c("el-button", {
                        attrs: {
                          icon: "el-icon-delete",
                          size: "mini",
                          type: "danger",
                        },
                        on: {
                          click: function ($event) {
                            _vm.isShowingManagerDeleteDialog = true
                          },
                        },
                      }),
                    ]
                  : _vm._e(),
              ],
              2
            ),
            _c(
              "div",
              { staticClass: "profile" },
              [
                _c(
                  "el-upload",
                  {
                    staticClass: "avatar-uploader",
                    attrs: {
                      "on-change": _vm.addedUserThumb,
                      action: "",
                      "auto-upload": false,
                      "show-file-list": false,
                      "on-success": _vm.successUpload,
                      "before-upload": _vm.beforeUpload,
                    },
                  },
                  [
                    _c("img", {
                      staticClass: "thumb",
                      attrs: { src: _vm.profileImage },
                      on: {
                        mouseover: function ($event) {
                          _vm.isMouseOveredDefaultProfImage = true
                        },
                        mouseleave: function ($event) {
                          _vm.isMouseOveredDefaultProfImage = false
                        },
                      },
                    }),
                  ]
                ),
                _c("span", { staticClass: "base name" }, [
                  _vm._v(_vm._s(_vm.currentUser.name)),
                ]),
                _c("span", { staticClass: "base email" }, [
                  _vm._v(_vm._s(_vm.currentUser.email)),
                ]),
                _c("span", { staticClass: "base note" }, [
                  _vm._v(_vm._s(_vm.currentUser.description)),
                ]),
                _c(
                  "span",
                  { staticClass: "base is-active" },
                  [
                    _vm._v(_vm._s(_vm.$t("Members.condition"))),
                    _vm.currentUser.is_active === true
                      ? _c(
                          "el-tag",
                          {
                            staticClass: "active",
                            attrs: { size: "mini", type: "success" },
                          },
                          [_vm._v(_vm._s(_vm.$t("Members.enabled")))]
                        )
                      : _c(
                          "el-tag",
                          {
                            staticClass: "inactive",
                            attrs: { size: "mini", type: "danger" },
                          },
                          [_vm._v(_vm._s(_vm.$t("Members.disabled")))]
                        ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "groups" },
              [
                _c("h2", [
                  _vm._v(_vm._s(_vm.$t("Members.title01"))),
                  _c("span", { staticClass: "count" }, [
                    _vm._v(_vm._s(_vm.managedGroups.length)),
                  ]),
                ]),
                _c(
                  "el-table",
                  {
                    attrs: {
                      id: "groups",
                      data: _vm.managedGroups,
                      "cell-class-name": "el-table-cell",
                      "row-class-name": "el-table-row",
                      "header-row-class-name": "el-table-header",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "name",
                        label: _vm.$t("Members.group_name"),
                        sortable: "",
                      },
                    }),
                    _vm.currentUser.role === "owner"
                      ? _c("el-table-column", {
                          attrs: {
                            prop: "manager.name",
                            label: _vm.$t("Cuona.Group.manager"),
                            sortable: "",
                          },
                        })
                      : _vm._e(),
                    _c("el-table-column", {
                      attrs: {
                        prop: "description",
                        label: _vm.$t("Members.note"),
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        width: "250px",
                        align: "center",
                        prop: "function",
                        label: _vm.$t("Members.functions"),
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (props) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text", size: "mini" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openUpdateDialog(
                                          props.row.id,
                                          props.row.manager_id ||
                                            props.row.manager.id
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("Members.changeManager"))
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2547556246
                      ),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: _vm.$t("Members.title02"),
                  visible: _vm.isShowingManagerDeleteDialog,
                },
                on: {
                  "update:visible": function ($event) {
                    _vm.isShowingManagerDeleteDialog = $event
                  },
                },
              },
              [
                0 < _vm.currentUser.groups.length
                  ? _c("span", [
                      _vm._v(_vm._s(_vm.$t("Members.description01"))),
                    ])
                  : _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("Members.description01", {
                            user: _vm.currentUser.name,
                          })
                        )
                      ),
                    ]),
                _c(
                  "span",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer",
                  },
                  [
                    0 < _vm.currentUser.groups.length
                      ? [
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function ($event) {
                                  _vm.isShowingManagerDeleteDialog = false
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("Members.close")))]
                          ),
                        ]
                      : [
                          _c(
                            "el-button",
                            {
                              attrs: { disabled: _vm.isLoading },
                              on: {
                                click: function ($event) {
                                  _vm.isShowingManagerDeleteDialog = false
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("Members.cancel")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "danger",
                                disabled: _vm.isLoading,
                              },
                              on: { click: _vm.deleteManager },
                            },
                            [_vm._v(_vm._s(_vm.$t("Members.delete")))]
                          ),
                        ],
                  ],
                  2
                ),
              ]
            ),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: _vm.$t("Members.title05"),
                  visible: _vm.isShowingManagerEditDialog,
                },
                on: {
                  "update:visible": function ($event) {
                    _vm.isShowingManagerEditDialog = $event
                  },
                },
              },
              [
                _c("p", { staticClass: "condition" }, [
                  _vm._v(_vm._s(_vm.$t("Members.condition"))),
                  _vm.currentUser.is_active === true
                    ? _c(
                        "span",
                        {
                          staticClass: "active",
                          attrs: { size: "mini", type: "success" },
                        },
                        [_vm._v(_vm._s(_vm.$t("Members.enabled")))]
                      )
                    : _c(
                        "span",
                        {
                          staticClass: "inactive",
                          attrs: { size: "mini", type: "danger" },
                        },
                        [_vm._v(_vm._s(_vm.$t("Members.disabled")))]
                      ),
                ]),
                _vm.currentUser.is_active
                  ? _c("span", {
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("Members.description04")),
                      },
                    })
                  : _c("span", {
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("Members.description05")),
                      },
                    }),
                _c(
                  "span",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer",
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { disabled: _vm.isLoading },
                        on: {
                          click: function ($event) {
                            _vm.isShowingManagerEditDialog = false
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("Members.close")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger", disabled: _vm.isLoading },
                        on: { click: _vm.editManager },
                      },
                      [_vm._v(_vm._s(_vm.$t("Members.edit")))]
                    ),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: _vm.$t("Members.changeManager"),
                  visible: _vm.isShowMemberUpdateDialog,
                },
                on: {
                  "update:visible": function ($event) {
                    _vm.isShowMemberUpdateDialog = $event
                  },
                },
              },
              [
                _c(
                  "el-form",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.isLoading,
                        expression: "isLoading",
                      },
                    ],
                    ref: "dialogForm",
                    attrs: {
                      "label-position": "left",
                      rules: _vm.rules,
                      "label-width": "120px",
                      model: _vm.dialogForm,
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("Cuona.Group.manager"),
                          prop: "managerId",
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              placeholder: _vm.$t("Cuona.Group.choice"),
                            },
                            model: {
                              value: _vm.dialogForm.managerId,
                              callback: function ($$v) {
                                _vm.$set(_vm.dialogForm, "managerId", $$v)
                              },
                              expression: "dialogForm.managerId",
                            },
                          },
                          _vm._l(_vm.ownerAndManagers, function (user, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { label: user.name, value: user.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "span",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer",
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { disabled: _vm.isLoading },
                        on: {
                          click: function ($event) {
                            _vm.isShowMemberUpdateDialog = false
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("Members.cancel")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", disabled: _vm.isLoading },
                        on: { click: _vm.updateGroupManager },
                      },
                      [_vm._v(_vm._s(_vm.$t("Members.edit")))]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }